import React, { Fragment, PureComponent, useState, useEffect, useContext, useReducer, useMemo, useCallback } from 'react';
import moment from 'moment';
import { connect, Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { merge, get, clone, set, findIndex } from 'lodash';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { withRouter, useHistory, useParams, useLocation, useRouteMatch } from 'react-router';
import { useDispatch, useMappedState, StoreContext } from 'redux-react-hook';
import { Button, List, Modal, Icon, Switch, InputItem, Toast, ActionSheet, Tabs } from 'antd-mobile';
// import Tloader from 'react-touch-loader';
import Tloader from '../../../components/loader';
import Vfalls from '../../../components/falls';
import { Loading } from '../../../components/loading';
import { TextDialog } from '../../../components/textDialog';
import { ShareBtn } from '../../../components/icons/share';
import { BackBtn } from '../../../components/icons/back';
import { ShareTip } from '../../../components/copyright/shareTip';
import { uploadImg, setHomepageStatus } from '../../commonAction';
import { Vh5Bar } from '../../../components/bar';
import { createCookie, readCookie, isVideoUrl, getPlatForm } from '../../../utils/common';
import { DetailShare } from '../../../components/copyright/detailShare';
import { getDownloadQRCode, sendDownloadInfo } from '../idetail/action';
import { getImgInfo } from '../idetail/action';
import { MINIPROGRAM_APPID } from '../../../utils/weixin';
import { getWeixinConfig, configWeixin } from '../../../utils/weixin';
import { Checked } from '../../../components/icons/checked';
import { getActivityContent, getPrizeList, getActivityDetail, setGalleryImgPraise, handleImgData, handlePrizeData, handleIndexData } from './action';
import { getUploadToken } from '../upload/action';
import { CommonFooter } from '../../../components/copyright/commonFooter';
import { ENV_TYPE } from '../../../env';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
import { Vh5Video } from '../../../components/videoPaler';
import { ImageInfo } from '../../../components/copyright/imageInfo';
import { DownloadTip } from '../../../components/downloadTip';
import 'video.js/dist/video-js.min.css';
import './index.scss';
// import { id } from 'postcss-selector-parser';
import LazyLoad from 'vanilla-lazyload';
import { _track } from '../../../utils/track';
let lazyLoadInstance = null;
const mapStateToProps = state => {
	return {
		detail: state.CopyrightActivityReducers.detail,
		imgList: state.CopyrightActivityReducers.imgList,
		prizeList: state.CopyrightActivityReducers.prizeList,
		totalCount: state.CopyrightActivityReducers.totalCount,
		pageIndex: state.CopyrightActivityReducers.pageIndex,
		pageSize: state.CopyrightActivityReducers.pageSize,
		isUpdate: state.CopyrightActivityReducers.isUpdate,
		baseInfo: state.CopyrightBaseinfoReducers.baseinfo
	};
};
function CopyrightActivity(props) {
	let praiseState = true;
	let history = useHistory();
	const mapState = useCallback(mapStateToProps, []);
	const { baseInfo, detail = {}, imgList = [], prizeList = [], totalCount, pageIndex, pageSize, isUpdate } = useMappedState(mapState);
	let { name, userNicename } = detail;
	let dispatch = useDispatch();
	let alert = Modal.alert;
	let params = useParams();
	let [showSheetStatus, setShowSheetStatus] = useState(false);
	let [effectFlag, setEffectFlag] = useState(1);
	let [countDown, setCountDown] = useState('');
	const [pageData, setPageData] = useState({
		isShowShareTip: false,
		isShowInstruction: false,
		isShowQRcodeInstruction: false,
		QRContent: '',
		isShowDownload: false,
		isShowShare: false,
		sharedData: {}
	});
	const [showInstruction, setShowInstruction] = useState(false);
	let [playerOptions, setPlayerOptions] = useState({});
	const [imgInfo, setImgInfo] = useState({
		id: '',
		contentId: '',
		type: 1,
		userId: 11610,
		userNickname: '4119昵称',
		key: '',
		thumbKey: '',
		picDescription: '',
		description: '',
		submitTime: 0,
		crDate: 0,
		lat: null,
		city: '',
		width: 600,
		height: 885,
		size: 32513,
		authorUserName: null,
		authorUserId: null,
		workTraceResps: []
	});
	const [cache, setCache] = useState(() => {
		return get(props, 'location.state.cache', false);
	});
	let [isDownloadTip, setIsDownloadTip] = useState(false);
	let [downloadItem, setDownloadItem] = useState({});
	let richtext = '';
	let { id, comeFrom } = params;
	console.log('comeFrom:', comeFrom);
	let userId = readCookie('copyrightuserId') || window['copyrightuserId'];
	let tabs = [{
		title: '活动相关作品'
	}, {
		title: '获奖作品'
	}];
	let instruction = `
		<p>1、投稿作品需选取色彩感情强烈、富有创意的摄影作品，内容须健康向上，无恶意攻击、谩骂及煽动诋毁性内容，无违法违规内容；</p>
		<p>2、作品允许恰当的修饰，对亮度、对比度、色调等方面适度调整，但谢绝合成作品；</p >
		<p>3、作品须为作者原创，上传者须拥有作品完整的著作权，并获得照片中所包含人物肖像权的使用许可及其它必要的许可，同时须保证上传的照片不侵犯任何第三人的著作权、肖像权、名誉权、隐私权、商标权、商号权及其他合法权益；作品涉及的肖像权、名誉权、著作权等法律责任均由上传者本人承担，征集发起方投图不承担由此引起的一切法律后果。</p >
		<p>4、作品一经上传，即视为作者授权同意所有上传图片由投图进行管理、使用或转授权他人使用，允许所有上传作品由投图进行展示、允许投图及媒体进行宣传、稿件配图等方式引用，包括但不限于投图平台各页面、VPHOTO微博、VPHOTO官方微信账号、媒体文章配图页面、媒体各对外渠道配图、媒体相关微博、此主题相关新闻稿件报道等等，并无须再另行通知或支付稿酬。</p >
		<p>5、本次投稿须知最终解释权归投图所有。</p>`;
	function uploadSheet(position) {
		if (!readCookie('copyrightphone')) {
			window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent('/vpmobile/copyright/activity/' + id);
			return;
		}
		dispatch(
			getUploadToken(null, data => {
				if (data.code !== 0) {
					createCookie('userToken', '', 180);
					alert('提示', '登录过期，是否去登录？', [
	          { text: '再看看', onPress: () => {} },
	          { text: '去登录', onPress: () => {
	          	window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent('/vpmobile/copyright/activity/' + id);
	          }},
	        ]);
					return;
				}
				_track({
					trackName: 'toutu_activity_page',
					payload: {
						Activity_Action: position === 'top' ? '顶部立即上传' : '底部立即上传'
					}
				});
				setShowSheetStatus(true);
				let textArray = [
					<div className="sheet-upload">
						上传照片
						<br />
						<span>最多可上传9张照片</span>
					</div>,
					<div className="sheet-upload">
						上传视频
						<br />
						<span>可上传1个 200M以内的视频</span>
					</div>,
					<div className="sheet-cancel">取消</div>
				];
				ActionSheet.showActionSheetWithOptions(
					{
						options: textArray,
						message: '上传照片、视频',
						maskClosable: true
						// wrapProps: {
						// 	onTouchStart: e => {
						// 		e.preventDefault()
						// 	},
						// }
					},
					buttonIndex => {
						setShowSheetStatus(false);
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								page_action_name: 'activity-pushpathname-upload',
								buttonIndex
							}
						});
						//0照片 1 视频
						const trackValues = ['上传照片', '上传视频', '取消'];
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								Activity_Action: trackValues[buttonIndex]
							}
						});
						setTimeout(() => {
							if (buttonIndex === 0 || buttonIndex === 1) {
								window.location.href = '/vpmobile/copyright/upload/' + (params.id || 'www') + '/' + buttonIndex + '/';
							}
						});
					}
				);
			})
		);
	}
	let handleLoadMore = resolve => {
		if (pageIndex * pageSize >= totalCount) {
			return;
		}
		let params = {
			index: pageIndex + 1,
			limit: pageSize,
			topicId: id,
			sort: -1
		};
		if (baseInfo.id && baseInfo.id !== 'null') {
			params.userId = baseInfo.id;
		}
		dispatch(
			getActivityContent(params, data => {
				dispatch({
					type: ACITONCOPYRIGHT.SET_COPYRIGHT_ACTIVITYIMGVALLFLAG,
					payload: {
						isUpdate: 0
					}
				});
				lazyLoadInstance.update();
				_track({
					trackName: 'toutu_activity_page',
					payload: {
						index: pageIndex + 1,
						limit: pageSize,
						sort: -1,
						page_action_name: 'activity-tloader-list'
					}
				});
				resolve();
			})
		);
	};
	let handleRefresh = (resove, reject) => {
		console.log('重新上拉加载刷新逻辑');
		resove();
	};
	function onPlayer({ id, topicId, url, type }) {
		const videoJsOptions = {
			autoplay: true,
			controls: true,
			fluid: true,
			controlBar: {
				fullscreenToggle: false
			},
			sources: [
				{
					src: url,
					type: type || 'video/mp4'
				}
			],
			data: {
				id,
				topicId,
				url
			},
			closeCallback: () => {
				setPlayerOptions({});
			}
		};
		setPlayerOptions(videoJsOptions);
	}

	function onShare(item, index) {
		_track({
			trackName: 'toutu_activity_page',
			payload: {
				id: item.id,
				shareType: '作品',
				page_action_name: 'activity-share'
			}
		});
		let shareData = {
			fromAvatar: item.avatar,
			fromName: item.nickname,
			// topicName: item.section,
			// title: item.description,
			// sectionId: item.sectionId,
			// contentId: item.contentId,
			title: item.sectionDescription,
			thumbKey: item.thumbKey || item.smallUrl
			// list: [{
			// 	key: item.url,
			// 	description: item.description
			// }]
		};
		if (item.mutil || isVideoUrl(item.url)) {
			shareData.sectionId = item.sectionId;
			shareData.list = imgList[index].responseList;
		} else {
			shareData.contentId = item.contentId;
			shareData.list = [
				{
					key: item.originalUrl || item.url,
					description: item.description
				}
			];
		}
		pageData.sharedData = shareData;
		pageData.isShowShare = true;
		setPageData({ ...pageData });
		console.log('showShare', shareData);
	}
	function closeShare() {
		pageData.isShowShare = false;
		setPageData({ ...pageData });
	}
	function uploadDownloadInfo(contentId) {
		let userId = readCookie('copyrightuserId');
		dispatch(
			sendDownloadInfo(
				{
					contentIds: [contentId],
					userId
				},
				data => {},
				data => {
					console.log('error data', data);
				}
			)
		);
	}
	function showQRCode(item) {
		if (pageData.isShowDownload) {
			return;
		}
		pageData.isShowDownload = true;
		setPageData({ ...pageData });

		// let _index = carouselIndex === -1 ? index : carouselIndex;
		let fd = new FormData();
		fd.append('appId', MINIPROGRAM_APPID);
		fd.append('downloadUrl', item.originalUrl);
		dispatch(
			getDownloadQRCode(
				fd,
				data => {
					pageData.isShowQRcodeInstruction = true;
					pageData.QRContent =
						'<div class="qrcode-wrap">' +
						'<img width="162" height="162" src="' +
						data.miniAppQrUrl +
						'" alt="小程序二维码" />' +
						'<div class="tip2">长按识别小程序码下载本视频</div>' +
						'</div>';
					setPageData(clone(pageData));
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
					// return '<div class="qrcode-wrap">' + '<img width="162" height="162" src="' + data.miniAppQrUrl + '" alt="小程序二维码" />' + '<div class="tip2">长按识别小程序码下载本图</div>' + '</div>';
					uploadDownloadInfo(item.contentId);
				},
				data => {
					console.log('error data', data);
					Toast.fail('生成小程序码失败');
					_track({
						trackName: 'toutu_idetail_page',
						payload: {
							...data,
							page_action_name: 'idetail-dialog-qrcode'
						}
					});
				}
			)
		);
	}

	function formatSource(list) {
		function formatItem(item) {
			let d = new Date(item.operateTime);
			let hour = String(d.getHours());
			let minute = String(d.getMinutes());
			let second = String(d.getSeconds());
			if (hour.length === 1) {
				hour = '0' + hour;
			}
			if (minute.length === 1) {
				minute = '0' + minute;
			}
			if (second.length === 1) {
				second = '0' + second;
			}
			return {
				time: hour + ':' + minute + ':' + second,
				operate: item.operate,
				comment: item.comment
			};
		}
		let stamps = [];
		let dataList = [];
		list.forEach(item => {
			let d = new Date(item.operateTime);
			let date = d.getDate();
			let month = d.getMonth() + 1;
			let year = d.getFullYear();
			let stamp = year + '.' + month + '.' + date;
			item = formatItem(item);
			if (!stamps.includes(stamp)) {
				stamps.push(stamp);
				dataList.push([item]);
			} else {
				dataList[dataList.length - 1].push(item);
			}
		});
		console.log([stamps, dataList]);
		return [stamps, dataList];
	}
	function source(resps) {
		let [stamps, dataList] = formatSource(resps);

		let iconMap = {
			SHOOT: '&#xe65d;',
			ORG_STMT: '&#xe660;',
			PUBLISH: '&#xe65c;'
		};
		function items(sourceList) {
			return sourceList.map(item => {
				return `<li>
						<span class="time">${item.time}</span>
						<span class="operate iconfont">${iconMap[item.operate] || ''}</span>
						<span class="comment">${item.comment}</span>
					</li>`;
			});
		}
		let list = stamps.map((stamp, index) => {
			return `<ul>
					<h3 class="date">${stamp}</h3>
					${items(dataList[index]).join('')}
				</ul>`;
		});

		return `<ul class="workTraceResps">${list.join('')}</ul>`;
	}
	function imageInfo(info) {
		//let { imgLayout = 'JPEG', imgSize = '4.3MB', imgPx = '6140 × 4912 像素', dateString = '2020年02月04日 12:00', author = 'Frank Wang' } = info || {};
		function videotype(key) {
			let index = key.lastIndexOf('.') + 1;
			return key.slice(index);
		}
		let equipment = ''; // 传输设备
		let location = imgInfo.city;
		let originalDocId = imgInfo.contentId;
		let isOriginal = imgInfo.isOriginal === 20; // 10：否  20：是
		let imgLayout = imgInfo.type === 1 ? 'JPEG' : videotype(imgInfo.key);
		let imgSize = parseFloat(imgInfo.size / 1024).toFixed(2) + 'KB';
		let imgPx = imgInfo.width + ' x ' + imgInfo.height + ' 像素';
		let dateString = moment(imgInfo.submitTime).format('YYYY-MM-DD HH:mm');
		let author = imgInfo.authorUserName || '未知';
		let resps = imgInfo.workTraceResps;
		return (
			'<div class="img-info-dialog">' +
			'<ul>' +
			(equipment ? `<li><label>传输设备</label><span>${equipment}</span></li>` : '') +
			'    <li>' +
			'        <label>视频格式</label>' +
			'        <span>' +
			imgLayout +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>视频大小</label>' +
			'        <span>' +
			imgSize +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>拍摄地点</label>' +
			'        <span>' +
			location +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>视频尺寸</label>' +
			'        <span>' +
			imgPx +
			'</span>' +
			'    </li>' +
			'    <li>' +
			'        <label>原始文档ID</label>' +
			'        <span>' +
			originalDocId +
			'</span>' +
			'    </li>' +
			'</ul>' +
			'<ul>' +
			'    <li>' +
			'        <label>视频溯源</label>' +
			(isOriginal ? '<div class="original"><span class="iconfont original-icon">&#xe660;</span><span>原创</span><div>' : '') +
			'    </li>' +
			// '    <li>' +
			// '        <label>照片提交于</label>' +
			// '        <span>' +
			// dateString +
			// '</span>' +
			// '    </li>' +
			// '    <li>' +
			// '        <label>照片提交者</label>' +
			// '        <span>' +
			// author +
			// '</span>' +
			// '    </li>' +
			'</ul>' +
			source(resps) +
			// '<ul>' +
			// '    <li>' +
			// '        <label>版权说明</label>' +
			// '        <span>可免费使用，但不可用于商业+用途，使用请注明出处。第三方权利说明：已获得模特肖像权授权</span>' +
			// '    </li>' +
			// '</ul>' +
			'</div>'
		);
	}
	function dialogQrCodeFooter() {
		pageData.isShowQRcodeInstruction = false;
		pageData.isShowDownload = false;
		setPageData(clone(pageData));
	}
	function dialogFooter() {
		pageData.isShowInstruction = false;
		setPageData(clone(pageData));
	}
	function getCurrentImgInfo(item) {
		console.log(item);
		// let item = items[index - 1];
		let { contentId } = item;
		dispatch(
			getImgInfo({ contentId }, data => {
				_track({
					trackName: 'toutu_idetail_page',
					payload: {
						...data,
						page_action_name: 'idetail-imginfo'
					}
				});
				setImgInfo(data);
				console.log('img info', data);
			})
		);
	}
	function onMore(item, index) {
		console.log(item, index);
		let textArray = ['视频信息', '下载视频', '取消'];
		ActionSheet.showActionSheetWithOptions(
			{
				options: textArray,
				//message: '上传照片、视频',
				maskClosable: true,
				wrapProps: {
					// onTouchStart: e => e.preventDefault()
				}
			},
			buttonIndex => {
				console.log(buttonIndex);
				if (buttonIndex === 0) {
					getCurrentImgInfo(item);
					pageData.isShowInstruction = true;
					setPageData(clone(pageData));
					//视频信息
				} else if (buttonIndex === 1) {
					//视频下载
					// showQRCode(item);
					setDownloadItem(item);
					onOpenTip();
				}
			}
		);
	}
	function onOpenTip() {
		setIsDownloadTip(true);
	}
	function onOpenTipNext() {
		setIsDownloadTip(false);
		showQRCode(downloadItem);
	}
	function onCloseTip() {
		setIsDownloadTip(false);
	}
	function onPraise(item, index) {
		if (!praiseState) {
			return;
		}
		praiseState = false;
		dispatch(
			getUploadToken(null, data => {
				if (data.code !== 0) {
					createCookie('userToken', '', 180);
					alert('提示', '登录过期，是否去登录？', [
						{ text: '再看看', onPress: () => {} },
						{
							text: '去登录',
							onPress: () => {
								window.location.href = '/vpmobile/copyright/login?redirect_pathname=' + encodeURIComponent(window.location.pathname);
							}
						}
					]);
					return;
				}
				console.log('praise', item);
				dispatch(
					setGalleryImgPraise(
						{
							operation: item.likeStatus === 0 ? 1 : 0,
							postId: item.sectionId,
							userId: baseInfo.id || 0,
							index,
							name: 'activity'
						},
						data => {
							praiseState = true;
						},
						data => {
							praiseState = true;
						}
					)
				);
			})
		);
	}
	function handleClickShareBtn() {
		pageData.isShowShareTip = true;
		setPageData({ ...pageData });
	}
	function handleClickShareTip() {
		pageData.isShowShareTip = false;
		setPageData({ ...pageData });
	}
//	useEffect(() => {
//		setTimeout(function() {
//			countDownTip(detail.endTime);
//		}, 1000);
//	});
	useEffect(() => {
		if (!cache || (effectFlag === 1 && imgList.length === 0)) {
			setCache(true);
			setEffectFlag(2);
			dispatch(
				getActivityDetail(
					{ topicId: id },
					data => {
						let { name, userNicename } = data;
						document.title = `#${name}# @${userNicename}，欢迎投稿`;
						console.log('...upload...', data);
						lazyLoadInstance.update();
						dispatch(
							getWeixinConfig({ url: window.location.href }, data => {
								configWeixin(data, {
									title: name,
									desc: `发起人${userNicename}，欢迎投稿`
								});
								_track({
									trackName: 'toutu_activity_page',
									payload: {
										...data,
										page_action_name: 'activity-init-wxconfig'
									}
								});
							})
						);
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								...data,
								come_from: comeFrom,
								page_action_name: 'activity-init-detail'
							}
						});
					},
					data => {
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								...data,
								come_from: comeFrom,
								page_action_name: 'activity-init-detail'
							}
						});
					}
				)
			);
			let params = {
				topicId: id || '',
				index: 1,
				limit: pageSize,
				sort: -1
			};
			if (userId && userId !== 'null') {
				params.userId = userId;
			}
			dispatch(
				getActivityContent(
					params,
					data => {
						lazyLoadInstance.update();
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								...data,
								page_action_name: 'activity-init-content'
							}
						});
					},
					data => {
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								...data,
								page_action_name: 'activity-init-content'
							}
						});
					}
				)
			);
			dispatch(
				getPrizeList(
					{
						topicId: id,
						userId: userId
					},
					data => {
						lazyLoadInstance.update();
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								...data,
								page_action_name: 'activity-prize-list'
							}
						});
					},
					data => {
						_track({
							trackName: 'toutu_activity_page',
							payload: {
								...data,
								page_action_name: 'activity-prize-list'
							}
						});
					}
				)
			);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 200
				// ... more custom settings?
			});
		} else if (effectFlag === 1 && cache) {
			//cache的时候数据没有变化，只是渲染
			setEffectFlag(2);
			lazyLoadInstance = new LazyLoad({
				elements_selector: '.lazy',
				load_delay: 200
				// ... more custom settings?
			});
			let top = get(props, 'location.state.top', 0);
			document.getElementsByClassName('tloader')[0].scrollTop = top;
		}
		return () => {
			document.title = '投图 - 主题影像即时创作平台';
		};
	}, [dispatch, id, comeFrom, pageSize, userId, cache, effectFlag, imgList, prizeList, props]);
	function remainDaysTip(timestamp) {
		let ms = timestamp - new Date().getTime();
		if (ms <= 0) {
			return '活动已结束';
		}
		return `活动将于${Math.ceil(ms / 1000 / 3600 / 24)}天后结束`;
	}
	function countDownTip(timestamp) {
		let ms = detail.endTime - new Date().getTime();
		if (ms <= 0) {
			setCountDown('');
			return;
		}
		let hours = 0;
		let minutes = 0;
		let seconds = 0;
		hours = Math.floor(ms / 1000 / 60 / 60);
		if (hours >= 24) {
			setCountDown(`${Math.ceil(hours / 24)} 天`);
		} else {
			minutes = Math.floor((ms - hours*60*60*1000) / 1000 / 60);
			seconds = Math.floor((ms - hours*60*60*1000 - minutes*60*1000) / 1000);
			if (minutes < 10) {
				minutes = '0'+minutes;
			}
			if (seconds < 10) {
				seconds = '0'+seconds;
			}
			setCountDown(`${hours} : ${minutes} : ${seconds}`);
		}
	}
	function bannerHeight() {
		let innerWidth = 0;
		if (getPlatForm() === 'PC') {
			innerWidth = 500;
		} else {
			innerWidth = window.innerWidth;
		}
		return (innerWidth * 260) / 670 + 'px';
	}
	function onToidetail(item, index) {
		let top = document.getElementsByClassName('tloader')[0].scrollTop;
		console.log('top', top);
		if (item.type === 2) {
			onPlayer({
				id: item.id,
				topicId: item.topicId,
				url: item.thumbVideoUrl,
				type: ''
			});
			return;
		}
		let objectProps = clone(defaultProps);
		let newItems = objectProps.items.filter(item => {
			if (item.type === 2) {
				return false;
			}
			return true;
		});
		let newArray = handleIndexData(imgList, index);
		let itemCount = newArray.items.length;
		let group_description_index = itemCount === 1 ? 0 : index;
		history.push({
			pathname: '/vpmobile/copyright/idetail',
			state: {
				defaultProps: newArray,
				topicName: detail.name,
				index: 0, // matchIndex,
				// sectionDescription: newArray.items[group_description_index].group_description,
				sectionDescription: item.sectionDescription,
				topicId: id,
				pathname: `/vpmobile/copyright/activity/${id}`,
				top
			}
		});
		_track({
			trackName: 'toutu_activity_page',
			payload: {
				index,
				page_action_name: 'activity-to-idetail',
				Activity_PictureShow: '活动页点击图片查看大图'
			}
		});
	}
	function handleClickBack() {
		history.push({
			pathname: '/vpmobile/copyright/events'
		});
	}
	function toCopyrightNotice() {
		history.push({
			pathname: '/vpmobile/copyright/notice'
		});
	}
	function BootomCard() {
		return (
			<section className="info bottom-info">
				<div className="bototm-info-box">
					<h2 className="topic-headline">
						<span className="iconfont topic"></span>
						{detail.name}
					</h2>
					<p>
						<span className="remainDays">{remainDaysTip(detail.endTime)}</span>
					</p>
					{detail.endTime > new Date().getTime() ? (
						<div
							className="uploader-btn"
							onClick={() => {
								uploadSheet('bottom');
							}}>
							立即上传
						</div>
					) : (
						<div className="uploader-btn over">活动已结束</div>
					)}
				</div>
			</section>
		);
	}
	function Organization(props) {
		return (
			<div className="organization">
				<Checked />
				<span>{props.name}</span>
			</div>
		);
	}
	function PromoterCard() {
		return (
			<div className="promoter">
				<div className="author">发起人</div>
				<div className="avatar">
					<img src={detail.avatar || 'https://gallerytemplate.vphotos.cn/copyright/default-avatar.jpg'} alt="" />
				</div>
				<div className="title">
					<span className="promoter-name">{detail.userNicename}</span>
					{detail.instName ? <Organization name={detail.instName} /> : ''}
				</div>
			</div>
		);
	}
	const actTypeIcons = {
		1: {
			iconFn: <i className={'iconfont public-benefit'}>&#xe662;</i>,
			text: '公益活动',
			className: 'public-benefit'
		},
		2: {
			iconFn: <i className={'iconfont reward'}>&#xe665;</i>,
			text: '悬赏活动',
			className: 'reward'
		},
		3: {
			iconFn: <i className={'iconfont flash'}>&#xe66b;</i>,
			text: '快闪活动',
			className: 'flash'
		}
	};
	function ActTypeIcon(prop) {
		let item = prop.item;
		let category = item.category;
		if (!category) {
			return '';
		}
		let type = actTypeIcons[category];
		return (
			<span className="act-type">
				{actTypeIcons[item.category].iconFn}
				<span className="text">{actTypeIcons[item.category].text}</span>
			</span>
		);
	}
	let defaultProps = handleImgData(imgList);
	let prizeProps = handlePrizeData(prizeList);
	return (
		<div className={'copyright copyright-activity' + (showSheetStatus ? ' other-copyright-acitivity' : '')}>
			<Tloader
				initializing={2}
				onRefresh={handleRefresh}
				hasMore={true}
				scrollBottom={520}
				onLoadMore={handleLoadMore}
				autoLoadMore={pageIndex * pageSize < totalCount /*false不会触发onLoadMore*/}
				className="tloader some class">
				<header className="banner" style={{ backgroundImage: `url('${detail.url}`, height: bannerHeight(), backgroundRepeat: 'round' }}>
					<BackBtn className="back-btn" onClick={handleClickBack} color="#fff" />
					<ShareBtn className="share-btn" onClick={handleClickShareBtn} />
					<ActTypeIcon item={detail} />
				</header>
				<section className="info">
					<div className="info-box">
						<h2>
							<span className="iconfont topic"></span>
							{detail.name}
						</h2>
						<p>
							<span className="remainDays">{remainDaysTip(detail.endTime)}</span>
						</p>
					</div>
					{detail.endTime > new Date().getTime() ? (
						<div
							className="uploader-btn"
							onClick={() => {
								uploadSheet('top');
							}}>
							立即上传
						</div>
					) : (
						<div className="uploader-btn over">活动已结束</div>
					)}
				</section>
				<PromoterCard />
				{get(detail, 'tags.length', 0) ? (
					<div className="tags-wrap">
						<div className="activity-tags">
							{detail.tags &&
								detail.tags.map((item, index) => {
									return (
										<span key={'activity-tags' + index}>
											<i>&#xe65f;</i>
											{item}
										</span>
									);
								})}
						</div>
					</div>
				) : (
					''
				)}
				{(detail.displayTime&&detail.endTime > new Date().getTime()) ? (
					<div className="activity-countDown">
						<div className="countDown-title">距离活动结束还有</div>
						<div className="countDown-value">{countDown}</div>
					</div>
				) : (
					''
				)}
				<section className="richtext" dangerouslySetInnerHTML={{ __html: detail.description }}></section>
				
				{detail.category === 2 ? (
					
					<Tabs tabs={tabs}
			      initialPage={0}
			      onChange={(tab, index) => { console.log('onChange', index, tab); }}
			      onTabClick={(tab, index) => { console.log('onTabClick', index, tab); }}
			    >
			      <div>
							<div className="vfalls-wrap">
								<Vfalls {...defaultProps} isDesc={true} onClick={onToidetail} onMore={onMore} onShare={onShare} onPraise={onPraise} update={isUpdate} />
							</div>
							{pageIndex * pageSize < totalCount ? <Loading /> : <div className="text">---- 我是底线，不能更低了 ----</div>}
			      </div>
			      <div>
			      	<section className="richtext" dangerouslySetInnerHTML={{ __html: detail.prizePublicity }}></section>
			      	{get(prizeList, 'length', 0) ? (
			      		<div>
				      		<div className="activity-title">所有获奖作品</div>
				      		<div className="vfalls-wrap">
										<Vfalls {...prizeProps} isDesc={true} onClick={onToidetail} onMore={onMore} onShare={onShare} onPraise={onPraise} update={isUpdate} />
				      		</div>
			      		</div>
			      	) : (
			      		<div className="activity-title">待活动结束后公示</div>
			      	)}
			      </div>
			    </Tabs>
				) : (
					<div>
						<div className="vfalls-wrap">
							<Vfalls {...defaultProps} isDesc={true} onClick={onToidetail} onMore={onMore} onShare={onShare} onPraise={onPraise} update={isUpdate} />
						</div>
						{pageIndex * pageSize < totalCount ? <Loading /> : <div className="text">---- 我是底线，不能更低了 ----</div>}
		      </div>
				)}
				
				
				
				<BootomCard />
				<div className="footer-wrap">
					<div className="footer-slogan">
						<img alt="" width="408" height="165" className="lazy" data-src="https://gallerytemplate.vphotos.cn/copyright/20200226/footer-logo.png" />
					</div>
					<div className="footer-tip">以主题性征集形式，汇聚即时、热点、品质原创影像内容，为所有的影像爱好者、媒体及平台提供优质原创图片/视频分享、版权维护等服务。</div>
					<CommonFooter />
				</div>
			</Tloader>
			{isDownloadTip ? <DownloadTip isDownloadTip={isDownloadTip} imgInfo={[downloadItem]} index={0} onClose={onCloseTip} onOpenTipNext={onOpenTipNext}></DownloadTip> : ''}
			{pageData.isShowShareTip ? <ShareTip path='/vpmobile/copyright/activity/' id={id} onClick={handleClickShareTip} /> : ''}
			{playerOptions && playerOptions.sources ? <Vh5Video {...playerOptions} /> : ''}
			{/* {pageData.isShowInstruction ? <TextDialog title="视频信息" text={imageInfo()} clickFooter={dialogFooter} footer={'关闭'} /> : ''} */}
			{pageData.isShowInstruction ? <ImageInfo text={imageInfo()} clickFooter={dialogFooter} clickIcon={toCopyrightNotice} footer={'关闭'} isVideo={true} /> : ''}
			{pageData.isShowShare ? <DetailShare data={pageData.sharedData} onClose={closeShare} /> : ''}
		</div>
	);
}
export { CopyrightActivity };
